import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/NegativeInventoryValuationReport/NegativeInventoryValuationReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingReportNegativeValuationActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/NegativeInventoryValuationReport/NegativeInventoryValuationReport")
	}

	render() {
		return (
			<Activity 
				name="AccountingNegativeInventoryValuationReport"
				RenderedComponent={this.RenderedComponent}
				context="AccountingNegativeInventoryValuationReport"
				action="AccountingNegativeInventoryValuationReport"
				formActions={FormAction}
            />
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingReportNegativeValuationActivity)
